import React, { useRef, useState } from 'react'
import { Box, Button, FormField, Text, TextInput } from 'grommet'
import { I18n, GlobalConfig, Constants } from 'galarm-config'
import { TaskManager } from 'galarm-shared'
import ReCAPTCHA from 'react-google-recaptcha'
import GalarmWebHeader from './GalarmWebHeader'

const EnterPhoneNumberScreen = ({ onCodeSent, onBack }) => {
  const [countryCode, setCountryCode] = useState('')
  const [mobileNumber, setMobileNumber] = useState('')
  const [error, setError] = useState('')
  const recaptchaRef = useRef(null)

  const onRequestCode = async () => {
    setError('')

    const sanitizedCountryCode = countryCode.replace(/\D/g, '')
    const sanitizedMobileNumber = mobileNumber.replace(/\D/g, '')

    if (!sanitizedCountryCode || !sanitizedMobileNumber) {
      setError(I18n.t('enterPhoneNumberForPremiumValidation'))
      return
    }

    const token = recaptchaRef.current?.getValue()
    if (!token) {
      setError(I18n.t('pleaseCompleteCaptcha'))
      return
    }
    recaptchaRef.current.reset()

    GlobalConfig.showProgress({
      state: Constants.ProgressStates.IN_PROGRESS,
      message: I18n.t('sendingVerificationCode', {
        formattedMobileNumber: `+${sanitizedCountryCode} ${sanitizedMobileNumber}`
      }),
      closeable: false
    })
    TaskManager.addHttpsCloudTask('sendAppVerificationCode', {
      countryCode: sanitizedCountryCode,
      mobileNumber: sanitizedMobileNumber,
      token
    })
      .then(taskResult => {
        GlobalConfig.dismissProgress()
        onCodeSent({
          mobileNumber: sanitizedMobileNumber,
          countryCode: sanitizedCountryCode,
          requestId: taskResult.result?.requestId || taskResult.requestId
        })
      })
      .catch(error => {
        GlobalConfig.dismissProgress()
        setError(
          I18n.t('unableToSendAppVerificationCode', {
            error: error.error || error.message || ''
          })
        )
      })
  }

  return (
    <Box fill>
      <GalarmWebHeader />

      {error ? (
        <Box
          pad={{ horizontal: 'large', vertical: 'small' }}
          background="status-error">
          <Text color="white" size="small" textAlign="center">
            {error}
          </Text>
        </Box>
      ) : null}

      <Box flex overflow="auto" align="center" justify="start" pad="large">
        <Box width="large" gap="medium" flex={{ shrink: 0 }}>
          <Box align="center" gap="small">
            <Text size="xlarge" weight="bold">
              {I18n.t('verifyAccount')}
            </Text>
            <Text
              textAlign="center"
              color="dark-4"
              style={{ whiteSpace: 'pre-line' }}>
              {I18n.t('phoneNumberForPremiumDescription')}
            </Text>
          </Box>

          <Box direction="row" gap="small" align="end">
            <FormField
              label={I18n.t('countryCode')}
              width="xsmall"
              margin="none">
              <TextInput
                placeholder="1"
                value={countryCode}
                onChange={e => setCountryCode(e.target.value)}
                type="tel"
                maxLength={4}
              />
            </FormField>
            <FormField label={I18n.t('mobileNumber')} flex margin="none">
              <TextInput
                placeholder="5551234567"
                value={mobileNumber}
                onChange={e => setMobileNumber(e.target.value)}
                type="tel"
              />
            </FormField>
          </Box>

          <Box align="center">
            <ReCAPTCHA
              ref={recaptchaRef}
              sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
            />
          </Box>

          <Box
            direction="row"
            align="center"
            gap="small"
            width="medium"
            alignSelf="center">
            <Button
              primary
              pad="small"
              fill="horizontal"
              label={
                <Text color="white">{I18n.t('requestVerificationCode')}</Text>
              }
              onClick={onRequestCode}
            />
            {onBack && (
              <Button
                pad="small"
                fill="horizontal"
                label={I18n.t('back')}
                onClick={onBack}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EnterPhoneNumberScreen
